var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M60 72L36 48L60 24","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronLeft.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
